import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useCreateStore } from '@/entities/create';
import { SelectTextbookStep } from '@/widgets/create-steps/SelectTextbookStep';
import { SelectMethodStep } from '@/widgets/create-steps/SelectMethodStep';
import { ConfirmDataStep } from '@/widgets/create-steps/ConfirmDataStep';
import { ConfirmQuestionStep } from '@/widgets/create-steps/ConfirmQuestionStep';

export const Route = createFileRoute('/create/')({
    component: RouteComponent,
});

function RouteComponent() {
    const { currentStep, type, setState } = useCreateStore();

    useEffect(() => {
        // 항상 step 1부터 시작 (다른 페이지 갔다 돌아올 때 리셋)
        setState('currentStep', 1);
        setState('curTextbookId', undefined);
        setState('setList', []);
        setState('setList', []);
        setState('sCurribook', undefined);
    }, []);

    return (
        <>
            <div style={{ display: currentStep === 1 ? 'block' : 'none' }}>
                <SelectTextbookStep />
            </div>
            <div style={{ display: currentStep === 2 ? 'block' : 'none' }}>
                <SelectMethodStep />
            </div>
            {currentStep === 3 && type === 'data' && <ConfirmDataStep />}
            {currentStep === 3 && type !== 'data' && <ConfirmQuestionStep />}
        </>
    );
}
